import { Size, LandingPad } from "./LandingPad";
export class SpaceShipConfig {
    size: Size;
    state: "hovering" | "landed" | "fueling" | "ready";
    frame: number; // AKA fuel level: 0 = empty, 8 = full

    constructor(size: Size, frame: number) {
        this.size = size;
        this.frame = frame;
    }
}

export class SpaceShip extends Phaser.GameObjects.Sprite {
    id: number;
    size: Size;
    state: "hovering" | "landed" | "fueling" | "ready";
    needsFuel: boolean;
    landingPad: LandingPad;

    constructor(scene: Phaser.Scene, id: number, x: number, y: number, config: SpaceShipConfig) {
        super(scene, x, y, config.size.id + "Ship", config.frame);
        this.id = id;
        this.size = config.size;
        this.state = "hovering";
        this.needsFuel = parseInt(this.frame.name) < 7;

        this.x = x + this.width / 2;
        this.y = y + this.height / 2;

        this.setDepth(5);
        this.setInteractive();

        this.scene.add.existing(this);
    }

    /**
     * All of the ships that will appear in the game
     */
    public static SpaceShipConfigs: SpaceShipConfig[] = [
        new SpaceShipConfig(Size.LARGE, 1),
        new SpaceShipConfig(Size.SMALL, 5),
        new SpaceShipConfig(Size.MEDIUM, 0),

        new SpaceShipConfig(Size.LARGE, 3),
        new SpaceShipConfig(Size.MEDIUM, 4),
        new SpaceShipConfig(Size.MEDIUM, 2),

        new SpaceShipConfig(Size.SMALL, 2),
        new SpaceShipConfig(Size.MEDIUM, 4),
        new SpaceShipConfig(Size.SMALL, 1),

        new SpaceShipConfig(Size.LARGE, 1),

    ];

}



// WEBPACK FOOTER //
// ./src/games/SpacePortGame/objects/SpaceShip.ts